import React, { useState } from 'react';
import ClosedTradeItem from './ClosedTradeItem';
import { useTranslation } from 'react-i18next';
const PAGE_SIZE = 20;

export default function PaginatedJournalClosedTradesTable({
  listData = {} as any,
  sortBy = '',
  searchTradingJounal = '',
}) {
  const [visibleRows, setVisibleRows] = useState(PAGE_SIZE);

  // Filter and sort logic (same as your code)
  const filteredSortedData = listData?.journal_closed_trades
    ?.sort((a: any, b: any) => {
      if (sortBy === 'close_time_desc') {
        return new Date(b.close_time).getTime() - new Date(a.close_time).getTime();
      } else if (sortBy === 'close_time_asc') {
        return new Date(a.close_time).getTime() - new Date(b.close_time).getTime();
      }
      return 0;
    })
    ?.filter((item: any) =>
      item.symbol?.toLowerCase().includes(searchTradingJounal.toLowerCase()) ||
      item.side?.toLowerCase().includes(searchTradingJounal.toLowerCase()) ||
      item.history_id?.toLowerCase().includes(searchTradingJounal.toLowerCase())
    );

  // Paginate the data
  const dataToShow = filteredSortedData?.slice(0, visibleRows);

  // Check if there are more items to load
  const hasMore = filteredSortedData?.length > visibleRows;

  // "Xem thêm" handler
  const handleLoadMore = () => {
    setVisibleRows((prev) => prev + PAGE_SIZE);
  };
  const { t } = useTranslation();

  return (
    <>
      <table className="_table_11ccc_13">
        <thead>
          <tr>
            <th colSpan={1} style={{ width: '160px', minWidth: '160px' }}>
              <div className="select-none text-headings-headline text-content-tertiary">{t('CloseTime')}</div>
            </th>
            <th colSpan={1} style={{ width: '140px', minWidth: '120px' }}>
              <div className="select-none text-headings-headline text-content-tertiary">{t('Symbol')}</div>
            </th>
            <th colSpan={1} style={{ width: '100px', minWidth: '90px' }}>
              <div className="select-none text-headings-headline text-content-tertiary">{t('Side')}</div>
            </th>
            <th colSpan={1} style={{ width: '100px', minWidth: '90px' }}>
              <div className="select-none text-headings-headline text-content-tertiary">{t('Volume')}</div>
            </th>
            <th colSpan={1} style={{ width: '140px', minWidth: '120px' }}>
              <div className="select-none text-headings-headline text-content-tertiary">{t('NetProfit')}</div>
            </th>
            {/* <th colSpan={1} style={{ width: '120px', minWidth: '100px' }}>
              <div className="select-none text-headings-headline text-content-tertiary">Commission</div>
            </th>
            <th colSpan={1} style={{ width: '120px', minWidth: '100px' }}>
              <div className="select-none text-headings-headline text-content-tertiary">Swap</div>
            </th> */}
            <th colSpan={1} style={{ width: '140px', minWidth: '120px' }}>
              <div className="select-none text-headings-headline text-content-tertiary">{t('GrossProfit')}</div>
            </th>
            <th colSpan={1} style={{ width: '160px', minWidth: '140px' }}>
              <div className="select-none text-headings-headline text-content-tertiary">{t('BalanceAfter')}</div>
            </th>
            <th colSpan={1} style={{ width: '100px', minWidth: '90px' }}>
              <div className="select-none text-headings-headline text-content-tertiary">Pips</div>
            </th>
          </tr>
        </thead>
        <tbody style={{ maxHeight: '1000px', overflowY: 'scroll' }}>
          {dataToShow?.map((item: any, index: any) => (
            <ClosedTradeItem key={index} data={item} />
          ))}
        </tbody>
      </table>
      {/* Load More Button */}
      {hasMore && (
        <div className='hide-mod' style={{ textAlign: 'center', margin: '16px 0' }}>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleLoadMore}
          >
            {t('Loadmore')}
          </button>
        </div>
      )}
    </>
  );
}